const elem = document.querySelector('.custom-reviews--slider-wrapper')
const reviewSlider =  new Swiper(elem, {
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 60,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable:true
  },
});

class VideoItem extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    this.querySelector('.start_button').addEventListener('click', (ev) => {
      const videoElement = this.querySelector('video');
      videoElement.play();
      this.classList.toggle('active')
    })
    this.querySelector('.stop_button').addEventListener('click', (ev) => {
      const videoElement = this.querySelector('video');
      this.classList.toggle('active')
      videoElement.pause();

    })
  }
}

customElements.define('video-item', VideoItem)

